// import "../node_modules/element-ui/lib/theme-chalk/index.css";
// import "../node_modules/element-theme-chalk";
// import "../node_modules/element-ui/packages/theme-chalk/src/index.scss";
// import "./styles/app.sass";
// import "./styles/app.styl";
import "./styles/app.css";
import Vue from "vue";
import store from "./store";
import Elements from "element-ui";
import enLocale from "element-ui/lib/locale/lang/en";
import uaLocale from "element-ui/lib/locale/lang/ua";
import ruLocale from "element-ui/lib/locale/lang/ru-RU";
import router from "./router";
import Features from "./features";
import VueI18n from "vue-i18n";
import Gravatar from "vue-gravatar";
import VueClipboard from "vue-clipboard2";
import VueKeycloakJs from "@dsb-norge/vue-keycloak-js";
import { LimeMenu } from "@shadoll/dandelion";

Vue.use(LimeMenu);

Vue.component("v-gravatar", Gravatar);

Vue.use(VueClipboard);

Vue.use(VueI18n);
const messages = {
  en: {
    title: "English",
    code: "en",
    ...enLocale
  },
  ua: {
    title: "Українська",
    code: "ua",
    ...uaLocale
  },
  ru: {
    title: "Русский",
    code: "ru",
    ...ruLocale
  }
};
const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: messages
});

Vue.use(Elements, { i18n: (key, value) => i18n.t(key, value) });

Vue.use(Features, { store, i18n });

const apolloProvider = Vue.prototype.$api.client;

const app = () =>
  new Vue({
    name: "appRoot",
    el: "#app",
    router,
    store,
    i18n,
    apolloProvider,
    render(h) {
      return h(require("./app.vue").default);
    },
    beforeCreate() {
      if (localStorage.getItem("whitebox_spa_mode") === "debug") {
        window.app = this;
        window.s = store;
      }
      store.getters["user/getBearer"];
      this.$api.catchHandler = res => {
        if (
          res.networkError &&
          res.networkError.result.status &&
          res.networkError.result.message === "Auth error."
        ) {
          this.$store.dispatch("user/logout");
          this.$router.replace({
            name: "login",
            query: {
              backto: this.$route.name,
              params: encodeURI(JSON.stringify(this.$route.params))
            }
          });
        }
        if (res.graphQLErrors && res.graphQLErrors instanceof Array) {
          res.graphQLErrors.forEach((e, i) => {
            setTimeout(
              () =>
                this.$notify.error({
                  title: "Error",
                  message: e.message
                }),
              150 * i
            );
          });
        }
      };
      window.addEventListener("keydown", function(e) {
        let el;
        if (
          e.code === "KeyF" &&
          e.ctrlKey &&
          (el = document.querySelector("[spa-action]"))
        ) {
          e.preventDefault();
          el.focus();
          el.scrollIntoView({ block: "center", behavior: "smooth" });
        }
      });
    },
    created() {
      this.$store.commit(
        "setLocale",
        this.$localStorage.get("locale") ||
          ((this.$keycloak || {}).tokenParsed || {}).locale ||
          "ru"
      );
      this.$i18n.locale = store.getters.locale;
    },
    watch: {
      locale(val) {
        this.$i18n.locale = val;
      }
    }
  });

Vue.config.productionTip = false;
if (JSON.parse(process.env.VUE_APP_KEYCLOAK_DISABLE_AUTH) === true) {
  app();
} else {
  Vue.use(VueKeycloakJs, {
    init: {
      onLoad: "check-sso"
    },
    config: {
      url: process.env.VUE_APP_KEYCLOAK_URL,
      clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
      realm: process.env.VUE_APP_KEYCLOAK_REALM
    },
    // eslint-disable-next-line no-unused-vars
    onReady: keycloak => {
      window.keycloak = keycloak;
      console.log(`I wonder what Keycloak returns: ${keycloak}`);
      app();
    }
  });
}
/**/
